import { Text } from "@radix-ui/themes";
import LoadingIndicator from "../../shared/LoadingIndicator";

export default function McpDashboardRedirectFlow() {
    const mcpUrl = import.meta.env.VITE_MCP_URL || window.location.origin;
    window.location.href = mcpUrl;

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                fontFamily: "system-ui, sans-serif",
            }}
        >
            <LoadingIndicator />
            <Text
                style={{
                    marginLeft: "10px",
                }}
            >
                Redirecting to dashboard...
            </Text>
        </div>
    );
}
